import { render, staticRenderFns } from "./Bigpackage.vue?vue&type=template&id=57a6e296&scoped=true&"
import script from "./Bigpackage.vue?vue&type=script&lang=js&"
export * from "./Bigpackage.vue?vue&type=script&lang=js&"
import style0 from "./Bigpackage.vue?vue&type=style&index=0&id=57a6e296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vbimex/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a6e296",
  null
  
)

export default component.exports